module.exports = {
      id: "arrow-down-usage",
      viewBox: "0 0 22.422 26.468",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#arrow-down",
      toString: function () {
        return this.url;
      }
    }